// extracted by mini-css-extract-plugin
export default {"title_box":"productComponent_title_box__HDwvF","img_box":"productComponent_img_box__fMPDW","line":"productComponent_line__fB9xV","app":"productComponent_app__Z7+WU"};